// @ts-nocheck
import React, { useCallback } from 'react';
import {
  Box,
  IconButton,
  DialogContent,
  Dialog,
  DialogTitle,
  Typography,
  Grid,
  Tooltip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import PropTypes from 'prop-types';

import AdvancedTableViewer from '../../AdvancedTableViewer';
import useModalDisclosure from '../../../../hooks/useModalDisclosure';
import { useDialogFullscreen } from '../../../../hooks/useDialogFullscreen';

const ViewAdvancedTable = ({ value, attribute }) => {
  const {
    open: openPreview,
    handleOpen: openModal,
    handleClose: closeModal,
  } = useModalDisclosure();
  const { isFullScreen, toggleFullScreen, exitFullScreen } =
    useDialogFullscreen();

  const handleClosePreview = useCallback(() => {
    closeModal();
  }, [closeModal]);

  const handleOpenPreview = useCallback(() => {
    openModal();
  }, [openModal]);

  return (
    <Grid container xs={12}>
      <Grid item xs={12}>
        <Typography
          variant="body2"
          component="span"
          onClick={handleOpenPreview}
          sx={{
            color: 'primary.main',
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
        >
          View {attribute?.label || 'Advanced Table'}
        </Typography>
      </Grid>

      <Dialog
        open={openPreview}
        onClose={handleClosePreview}
        maxWidth={isFullScreen ? false : 'lg'}
        fullWidth
        fullScreen={isFullScreen}
        TransitionProps={{
          onExited: () => exitFullScreen(),
        }}
        PaperProps={{
          sx: {
            maxHeight: isFullScreen ? '100vh' : '90vh',
            height: isFullScreen ? '100vh' : 'auto',
          },
        }}
      >
        <DialogTitle>
          <Box component="span" aria-live="polite" aria-atomic="true">
            {attribute?.label}
          </Box>
        </DialogTitle>

        {/* Fullscreen Button */}
        <Tooltip title={isFullScreen ? 'Exit Full Screen' : 'Full Screen'}>
          <IconButton
            color="primary"
            aria-label={isFullScreen ? 'Exit full screen' : 'Enter full screen'}
            onClick={toggleFullScreen}
            sx={{
              position: 'absolute',
              right: 56,
              top: 8,
            }}
          >
            {isFullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </IconButton>
        </Tooltip>

        <IconButton
          color="primary"
          aria-label="Close dialog"
          onClick={handleClosePreview}
          sx={{
            position: 'absolute',
            right: 16,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <AdvancedTableViewer attribute={attribute} value={value} />
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

ViewAdvancedTable.propTypes = {
  value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])).isRequired,
  attribute: PropTypes.object.isRequired.isRequired,
};

export default ViewAdvancedTable;
